// @flow
import {pathOr} from 'ramda';

import type {SelectorType} from 'constants/flow/flowTypes';

/**
 * Returns previously visited product identifier
 * @type {SelectorType<number>}
 */
export const getPreviousProductIdentifier: SelectorType<number> = pathOr(0, [
    'previousProductIdentifier',
]);
